import { getBirthDisabledDates } from '@utils/index';
import { EUserType } from '@xeppt/xeppt-sdk/types/user';

export const defaultAddressData = {
    country: '',
    city: '',
    address_2: '',
    address_1: '',
    zip_code: '',
    region: ''
};

export const defaultBusinessData = {
    company_name: '',
    trading_name: '',
    registration_number: '',
    category: '',
    size: '',
    website: ''
};

export const defaultPersonalInfo = {
    email: '',
    phone_number: '',
    phone_code: '',
    profile: {
        first_name: '',
        last_name: '',
        birthday: getBirthDisabledDates()
    },
    billing_address: defaultAddressData
};

export const defaultPersonalSignUpData = {
    email: '',
    phone_number: '',
    phone_code: '',
    profile: {
        first_name: '',
        last_name: '',
        birthday: getBirthDisabledDates(),
        occupancy: ''
    },
    billing_address: defaultAddressData,
    type: EUserType.INDIVIDUAL,
    verificationCode: ''
};

export const defaultBusinessSignUpData = {
    email: '',
    phone_number: '',
    phone_code: '',
    profile: {
        first_name: '',
        last_name: '',
        birthday: getBirthDisabledDates(),
        occupancy: '',
        residence: ''
    },
    business_address: defaultAddressData,
    registration_address: defaultAddressData,
    registrationSameBusiness: false,
    trading_address: defaultAddressData,
    tradingSameBusiness: false,
    type: EUserType.BUSINESS,
    verificationCode: '',
    business: {
        company_name: '',
        trading_name: '',
        registration_number: '',
        category: '',
        size: '',
        website: ''
    }
};

export const defaultSignInData = {
    email: '',
    password: ''
};

export const defaultForgotPassword = {
    email: '',
    phone_code: '',
    phone_number: '',
    password: '',
    password_confirm: ''
};

export const defaultProfileSettingsData = {
    ...defaultPersonalInfo,
    type: EUserType.BUSINESS
};

export const defaultLinkCard = {
    first_name: '',
    last_name: '',
    card_number: '',
    expire: '',
    code: ''
};

export const defaultLinkBank = {
    institutionNumber: '',
    transitNumber: '',
    accountNumber: '',
    type: ''
};

export const addressValidationErrors = (localization: (value: string) => string) => ({
    address_1: localization('address_1'),
    address_2: localization('address_2'),
    zip_code: localization('zip_code'),
    city: localization('city'),
    country: localization('country'),
    region: localization('region')
});
